<template>
  <div class="trainer-sidebar" 
       :class="{ 
         'collapsed': collapsed,
         'mobile-open': mobileOpen 
       }">
    
    <!-- Trainer Profile Header -->
    <div class="trainer-profile-header">
      <div class="trainer-avatar">
        <img src="/static/img/faces/avatar.png" alt="Personal Trainer" />
        <div class="trainer-status-indicator"></div>
      </div>
      <div class="trainer-info" v-show="!collapsed">
        <h6 class="trainer-name">Carlos Rodríguez</h6>
        <p class="trainer-role">Personal Trainer</p>
        <div class="trainer-status">
          <span class="status-dot"></span>
          <span class="status-text">En línea</span>
        </div>
      </div>
      
      <!-- Botón de cerrar sesión -->
      <div class="trainer-logout-container">
        <button 
          class="trainer-logout-sidebar-btn" 
          @click="handleLogout"
          :title="collapsed ? 'Cerrar Sesión' : ''"
        >
          <i class="nc-icon nc-button-power"></i>
          <span v-show="!collapsed">Cerrar Sesión</span>
        </button>
      </div>
    </div>
    
    <div class="sidebar-wrapper">
      <ul class="nav">
        <li class="nav-item" v-for="item in menuItems" :key="item.name">
          <router-link 
            class="nav-link" 
            :to="{ name: item.name }"
            active-class="active"
            @click="$emit('item-click')"
            :data-title="item.title"
          >
            <i :class="item.icon"></i>
            <p v-show="!collapsed" :class="{ 'multiline-text': item.multiline }">
              <span v-if="item.multiline" v-html="item.displayText"></span>
              <span v-else>{{ item.displayText }}</span>
            </p>
          </router-link>
        </li>
      </ul>
    </div>
    
    <!-- Trainer Footer -->
    <div class="trainer-sidebar-footer" v-show="!collapsed">
      <div class="version-info">
        <div class="logo-mini">
          <img src="/static/img/central-gym150x150.webp" alt="CentralGym" />
        </div>
        <div class="version-text">
          <p class="brand-name">CentralGym Fit-Tracker</p>
          <p class="version-number">v0.0.1 (alpha)</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainerSidebar',
  props: {
    collapsed: {
      type: Boolean,
      default: false
    },
    mobileOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuItems: [
        {
          name: 'TrainerDashboard',
          title: 'Dashboard',
          displayText: 'Dashboard',
          icon: 'nc-icon nc-chart-pie-36',
          multiline: false
        },
        {
          name: 'TrainerProfile',
          title: 'Mi Perfil',
          displayText: 'Mi Perfil',
          icon: 'nc-icon nc-single-02',
          multiline: false
        },
        {
          name: 'TrainerClients',
          title: 'Mis Clientes',
          displayText: 'Mis Clientes',
          icon: 'nc-icon nc-user-run',
          multiline: false
        },
        {
          name: 'ExerciseLibrary',
          title: 'Biblioteca de Ejercicios',
          displayText: 'Biblioteca de<br>Ejercicios',
          icon: 'nc-icon nc-app',
          multiline: true
        },
        {
          name: 'WorkoutBuilder',
          title: 'Constructor de Planes',
          displayText: 'Constructor de<br>Planes',
          icon: 'nc-icon nc-settings-gear-65',
          multiline: true
        },
        {
          name: 'Evaluations',
          title: 'Evaluaciones',
          displayText: 'Evaluaciones',
          icon: 'nc-icon nc-paper',
          multiline: false
        },
        {
          name: 'ClientProgress',
          title: 'Progreso de Clientes',
          displayText: 'Progreso<br>Clientes',
          icon: 'nc-icon nc-chart-bar-32',
          multiline: true
        },
        {
          name: 'Communication',
          title: 'Comunicación',
          displayText: 'Comunicación',
          icon: 'nc-icon nc-chat-33',
          multiline: false
        },
        {
          name: 'Schedule',
          title: 'Agenda',
          displayText: 'Agenda',
          icon: 'nc-icon nc-calendar-60',
          multiline: false
        },
        {
          name: 'TrainerSettings',
          title: 'Configuración',
          displayText: 'Configuración',
          icon: 'nc-icon nc-settings',
          multiline: false
        }
      ]
    }
  },
  methods: {
    handleLogout() {
      this.$emit('logout');
    }
  }
}
</script>

<style lang="scss" scoped>
/* Paleta de colores oscura y elegante */
.trainer-sidebar {
  --trainer-primary: #9ACD32;    /* Verde lima para elementos activos */
  --trainer-secondary: #7CB342;  /* Verde para hover */
  --trainer-accent: #8BC34A;     /* Verde intermedio */
  --trainer-dark: #353535;       /* Gris oscuro principal */
  --trainer-light: #4a4a4a;      /* Gris claro para opciones */
  --trainer-bg: #2c2c2c;         /* Fondo principal oscuro */
  
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 260px;
  display: block;
  z-index: 1000;
  color: #fff;
  font-weight: 200;
  background-size: cover;
  background-position: center center;
  background: var(--trainer-bg);
  box-shadow: 0 0 20px rgba(0,0,0,.3);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow: hidden; /* Evitar overflow en el contenedor principal */

  &.collapsed {
    width: 70px;
    overflow: hidden; /* Asegurar que el contenido no se salga */
    
    .trainer-profile-header {
      padding: 15px 5px;
      min-height: 70px;
      
      .trainer-avatar {
        margin: 0 auto;
        
        img {
          width: 40px;
          height: 40px;
          transition: all 0.3s ease;
        }
        
        .trainer-status-indicator {
          transform: scale(0.8);
        }
      }
      
      .trainer-logout-container {
        margin-top: 10px;
        padding-top: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        
        .trainer-logout-sidebar-btn {
          width: 40px;
          height: 40px;
          padding: 0;
          border-radius: 50%;
          position: relative;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          
          i {
            font-size: 16px;
          }
          
          span {
            display: none;
          }
        }
      }
    }
    
    .sidebar-wrapper {
      padding: 5px 0;
      overflow: hidden; /* Evitar overflow horizontal */
      
      .nav .nav-item .nav-link {
        position: relative;
        overflow: hidden; /* Contener contenido dentro del enlace */
        margin: 2px 8px;
        padding: 10px 0;
        text-align: center;
        display: flex !important;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 44px;
        width: calc(100% - 16px); /* Asegurar que no se salga del contenedor */
        box-sizing: border-box;
        
        i {
          font-size: 18px;
          margin: 0;
          width: auto;
          line-height: 1;
          color: rgba(255,255,255,0.8);
        }
        
        p {
          display: none !important;
        }
        
        /* Tooltip para mostrar texto en hover */
        &::after {
          content: attr(data-title);
          position: absolute;
          left: 70px;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(0,0,0,0.9);
          color: white;
          padding: 8px 12px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
          white-space: nowrap;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
          z-index: 1000;
          pointer-events: none;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }
        
        /* Flecha del tooltip */
        &::before {
          content: '';
          position: absolute;
          left: 65px;
          top: 50%;
          transform: translateY(-50%);
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-bottom: 5px solid transparent;
          border-right: 5px solid rgba(0,0,0,0.9);
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
          z-index: 1000;
          pointer-events: none;
        }
        
        &:hover {
          transform: none;
          background: rgba(255,255,255,0.2) !important;
          
          i {
            font-size: 22px;
            color: white !important;
          }
          
          &::after {
            opacity: 1;
            visibility: visible;
            left: 75px;
          }
          
          &::before {
            opacity: 1;
            visibility: visible;
            left: 70px;
          }
        }
        
        &.active {
          background: var(--trainer-primary) !important;
          box-shadow: 0 4px 15px 0px rgba(154, 205, 50, 0.4) !important;
          
          i {
            color: white !important;
            font-size: 22px;
          }
        }
      }
    }
  }

  .trainer-profile-header {
    padding: 20px 15px;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    text-align: center;
    transition: all 0.3s ease;
    flex-shrink: 0;
    background: var(--trainer-dark);
    position: relative;
    z-index: 10;
    
    .trainer-avatar {
      position: relative;
      display: inline-block;
      margin-bottom: 10px;
      
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 3px solid rgba(255,255,255,0.3);
        object-fit: cover;
        background: white;
      }
      
      .trainer-status-indicator {
        position: absolute;
        bottom: 2px;
        right: 2px;
        width: 16px;
        height: 16px;
        background: #4CAF50;
        border: 2px solid white;
        border-radius: 50%;
      }
    }
    
    .trainer-info {
      .trainer-name {
        color: white;
        font-size: 16px;
        font-weight: 600;
        margin: 0 0 5px 0;
      }
      
      .trainer-role {
        color: rgba(255,255,255,0.8);
        font-size: 12px;
        margin: 0 0 8px 0;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      
      .trainer-status {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        color: rgba(255,255,255,0.7);
        
        .status-dot {
          width: 6px;
          height: 6px;
          background: #4CAF50;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
    }
  }
  
  .trainer-logout-container {
    margin-top: 15px;
    padding-top: 10px;
    border-top: 1px solid rgba(255,255,255,0.15);
    
    .trainer-logout-sidebar-btn {
      background: rgba(220, 53, 69, 0.1);
      border: 1px solid rgba(220, 53, 69, 0.3);
      color: #dc3545;
      padding: 8px 12px;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 500;
      width: 100%;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      cursor: pointer;
      
      &:hover {
        background: rgba(220, 53, 69, 0.2);
        border-color: #dc3545;
        color: #dc3545;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(220, 53, 69, 0.2);
      }
      
      &:active {
        transform: translateY(0);
      }
      
      &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.3);
      }
      
      i {
        font-size: 14px;
        flex-shrink: 0;
      }
      
      span {
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }
  }

  .sidebar-wrapper {
    flex: 1;
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px 0;
    min-height: 0;

    .nav {
      display: block;

      .nav-item {
        position: relative;

        .nav-link {
          color: rgba(255,255,255,0.9);
          margin: 3px 15px;
          border-radius: 8px;
          opacity: .9;
          transition: all 300ms ease;
          position: relative;
          display: flex;
          align-items: center;
          padding: 12px 15px;
          text-decoration: none;
          min-height: 48px;
          background: var(--trainer-light);

          &:hover {
            color: #FFFFFF;
            background: rgba(255,255,255,0.15);
            transform: translateX(3px);
          }

          &.active {
            color: #FFFFFF;
            background: var(--trainer-primary);
            box-shadow: 0 4px 20px 0px rgba(0,0,0,0.14), 0 7px 10px -5px rgba(154, 205, 50, 0.4);
          }

          i {
            font-size: 16px;
            margin-right: 15px;
            line-height: 20px;
            width: 24px;
            text-align: center;
            color: rgba(255,255,255,0.8);
            flex-shrink: 0;
          }

          p {
            margin: 0;
            position: relative;
            line-height: 20px;
            font-size: 14px;
            font-weight: 400;
            transition: all 0.3s ease;
            opacity: 1;
            flex: 1;
            
            &.multiline-text {
              line-height: 16px;
              font-size: 13px;
            }
          }
        }
      }
    }
  }
  
  .trainer-sidebar-footer {
    padding: 15px;
    border-top: 1px solid rgba(255,255,255,0.1);
    background: var(--trainer-dark);
    flex-shrink: 0;
    position: relative;
    z-index: 10;
    min-height: 80px;
    margin-top: auto;
    
    .version-info {
      display: flex;
      align-items: center;
      
      .logo-mini {
        margin-right: 10px;
        
        img {
          width: 32px;
          height: 32px;
          border-radius: 6px;
        }
      }
      
      .version-text {
        flex: 1;
        
        .brand-name {
          color: white;
          font-size: 12px;
          font-weight: 600;
          margin: 0 0 2px 0;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .version-number {
          color: rgba(255,255,255,0.7);
          font-size: 10px;
          margin: 0;
          font-weight: 400;
        }
      }
    }
  }
}

/* Responsive */
@media (max-width: 991px) {
  .trainer-sidebar {
    transform: translate3d(-260px, 0, 0);
    
    &.mobile-open {
      transform: translate3d(0, 0, 0);
    }
  }
}

/* Scrollbar personalizado para sidebar */
.sidebar-wrapper::-webkit-scrollbar {
  width: 6px;
}

.sidebar-wrapper::-webkit-scrollbar-track {
  background: rgba(255,255,255,0.1);
  border-radius: 3px;
}

.sidebar-wrapper::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.3);
  border-radius: 3px;
  
  &:hover {
    background: rgba(255,255,255,0.5);
  }
}
</style>